import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import utils from 'utils';
import { isFetchingEndpointSelector } from 'selectors/fetchingSelectors';

/**
 * Simple hook that triggers a full-page loading overlay based on a fetching state.
 *
 * @param {object} opts - details the fetch calls being monitored in order to show the loading overlay.
 *  @see isFetchingEndpointSelector for opts details
 */
const useLoadingOverlay = opts => {
  const isFetching = useSelector(state => isFetchingEndpointSelector(state, opts));

  useEffect(
    () => {
      utils.dom.loadingOverlay(isFetching);
    },
    [isFetching]
  );
};

export default useLoadingOverlay;
